import {
    UNIT_TYPE_EVENTS_OPEN_MODAL,
    UNIT_TYPE_EVENTS_SEARCH_REQUEST,
    UNIT_TYPE_EVENTS_SEARCH_RESULT,
} from 'Redux/actionTypes';

export const unitTypeEventsOpenModal = (open, from) => ({
    type: UNIT_TYPE_EVENTS_OPEN_MODAL,
    payload: { open, from }
})

export const searchUnitTypeEventsRequest = (data) => ({
    type: UNIT_TYPE_EVENTS_SEARCH_REQUEST,
    payload: data
})

export const eventSearchUnitTypeEventsResult = (result) => ({
    type: UNIT_TYPE_EVENTS_SEARCH_RESULT,
    payload: result
})